













































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import { dateTime } from '@/util/adapter';
import Cookies from 'js-cookie';
import moment from 'moment';
const { VUE_APP_FCREST: FCREST } = process.env;
const API = {
  region: `${FCREST}/promotion/shang/region`,
  regionList: '/region.json',
};
const dateFormat = require('bmh/date-format');

@Component
export default class Link extends Vue {
  isShowRegionModal: boolean = false;
  isLoading: boolean = true;
  modal_title: string = '新增区域';
  province_list_all: any = [];
  form: any = {
    sort: {},
    region_name: {},
    region_name_spell: {},
    address: {},
  };
  distriict_list: any = [];
  city_list: any = [];
  tableData: any = {};

  formItemLayout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size || 1,
      current: data.current || 1,
    };
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  // 新增区域按钮
  addRegion() {
    this.modal_title = '新增区域';
    this.isShowRegionModal = true;
  }

  // 编辑操作
  edit(item: any) {
    this.modal_title = '编辑区域';
    this.form = {
      id: item.id,
      sort: {
        value: item.sort,
      },
      region_name: {
        value: item.region_name,
      },
      region_name_spell: {
        value: item.region_spell,
      },
      address: {
        regionProvince: item.province === 1 ? '全国' : String(item.province),
        regionCity: String(item.city),
        regionDistrict: String(item.district),
      },
    };
    if (item.province) {
      this.province_list_all.forEach((e: any) => {
        if (String(item.province) === String(e.id)) {
          this.city_list = e.children;
        }
      });
      const arr = [];
      for (const key in this.city_list) {
        if (key) {
          arr.push({
            id: key,
            name: this.city_list[key].name,
            children: this.city_list[key].children,
          });
        }
      }
      this.city_list = arr;
    }
    if (item.city) {
      this.city_list.forEach((e: any) => {
        if (String(item.city) === String(e.id)) {
          this.distriict_list = e.children;
        }
      });
      const distr_arr = [];
      for (const key in this.distriict_list) {
        if (key) {
          distr_arr.push({ id: key, name: this.distriict_list[key].name });
        }
      }
      this.distriict_list = distr_arr;
      console.debug(distr_arr);
      if (this.distriict_list.length === 0) {
        this.form.address.regionCity = undefined;
        this.form.address.regionDistrict = undefined;
      }
    } else {
      this.form.address.regionCity = undefined;
      this.form.address.regionDistrict = undefined;
    }
    if (!item.district) {
      this.form.address.regionDistrict = undefined;
    }
    this.isShowRegionModal = true;
  }

  async created() {
    // await this.query();
    await this.getCityList();
    await this.query(1);
  }

  query(page: number) {
    this.isLoading = true;
    axios
      .get(`${API.region}?is_pagination=1&page=${page}`)
      .then((res) => {
        this.isLoading = false;
        if (res.data) {
          if (res.data.status === 200) {
            this.tableData = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  getCityList() {
    this.province_list_all = [];
    this.$axios.get(API.regionList).then((res: AxiosResponse) => {
      const remote = res.data;
      const arr = [];
      const distriict_arr = [];
      for (const key in remote) {
        if (key) {
          this.province_list_all.push({
            id: key,
            name: remote[key].name,
            children: remote[key].children,
          });
        }
      }
    });
    // this.province_list_all.push({id: 1, name: '全国', children: {}});
  }

  provinceCheckChange(data: any) {
    if (!data) {
      this.form.address.regionCity = undefined;
      this.form.address.regionDistrict = undefined;
      this.city_list = [];
      this.distriict_list = [];
      this.form.address.status = 'error';
      this.form.address.error = '请选择省市区';
      return;
    }
    this.form.address.status = '';
    this.form.address.error = '';
    this.province_list_all.forEach((item: any) => {
      if (data === item.id) {
        this.city_list = item.children;
      }
    });

    const arr = [];
    for (const key in this.city_list) {
      if (key) {
        arr.push({
          id: key,
          name: this.city_list[key].name,
          children: this.city_list[key].children,
        });
      }
    }
    this.city_list = arr;
  }

  cityCheckChange(data: any) {
    if (!data) {
      this.form.address.regionDistrict = undefined;
      this.distriict_list = [];
      return;
    }
    this.city_list.forEach((item: any) => {
      if (data === item.id) {
        this.distriict_list = item.children;
      }
    });
    const arr = [];
    for (const key in this.distriict_list) {
      if (key) {
        arr.push({ id: key, name: this.distriict_list[key].name });
      }
    }
    this.distriict_list = arr;
  }

  checkClick(data: string) {
    let error = 0;
    if (data === 'sort') {
      if (!this.form.sort.value && this.form.sort.value !== 0) {
        this.form.sort.status = 'error';
        this.form.sort.error = '请输入排序';
        error = 1;
      } else {
        this.form.sort.status = '';
        this.form.sort.error = '';
      }
      return error;
    }

    if (data === 'region_name') {
      if (!this.form.region_name.value) {
        this.form.region_name.status = 'error';
        this.form.region_name.error = '请输入区域名称';
        error = 1;
      } else {
        this.form.region_name.status = '';
        this.form.region_name.error = '';
      }
      return error;
    }

    if (data === 'region_name_spell') {
      if (!this.form.region_name_spell.value) {
        this.form.region_name_spell.status = 'error';
        this.form.region_name_spell.error = '请输入名称全拼';
        error = 1;
      } else {
        this.form.region_name_spell.status = '';
        this.form.region_name_spell.error = '';
      }
      return error;
    }
  }

  submitRegion() {
    this.checkClick('sort');
    this.checkClick('region_name');
    this.checkClick('region_name_spell');
    this.$forceUpdate();
    if (!this.form.address.regionProvince) {
      this.form.address.status = 'error';
      this.form.address.error = '请选择省市区';
      return;
    }
    if (
      this.checkClick('sort') === 0 &&
      this.checkClick('region_name') === 0 &&
      this.checkClick('region_name_spell') === 0
    ) {
      const data = {
        id: this.form.id,
        sort: this.form.sort.value,
        region_name: this.form.region_name.value,
        region_spell: this.form.region_name_spell.value,
        province: this.form.address.regionProvince,
        city: this.form.address.regionCity,
        district: this.form.address.regionDistrict,
      };
      if (this.modal_title === '新增区域') {
        axios.post(API.region, data).then((res) => {
          if (res.data) {
            if (res.data.status === 200) {
              this.isShowRegionModal = false;
              this.cancelClick();
              this.query(1);
            } else {
              this.$message.error(res.data.message);
            }
          }
        });
      } else if (this.modal_title === '编辑区域') {
        axios.put(`${API.region}/${this.form.id}`, data).then((res) => {
          if (res.data) {
            if (res.data.status === 200) {
              this.isShowRegionModal = false;
              this.cancelClick();
              this.query(1);
            } else {
              this.$message.error(res.data.message);
            }
          }
        });
      }
    }
  }
  cancelClick() {
    this.form = {
      sort: {},
      region_name: {},
      region_name_spell: {},
      address: {},
    };
    this.city_list = [];
    this.distriict_list = [];
  }
}
